import { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { ConfirmationDialog } from '@collaborate-health/uikit'
import { sessionTitleFormatter } from '@tabeeb/shared/utils/text'
import { publishSession } from '@tabeeb/modules/sessionsPage/actions'
import { getTenantName } from '@tabeeb/modules/appConfigState/selectors'

const PublishSessionDialog = ({ open, session, onClose }) => {
  const dispatch = useDispatch()

  const tenantName = useSelector(getTenantName)

  const onSubmit = useCallback(() => {
    dispatch(publishSession.request({ contentId: session.Id, isRepublish: session.IsPublished }))

    onClose()
  }, [dispatch, onClose, session?.Id, session?.IsPublished])

  return (
    <ConfirmationDialog
      isOpen={open}
      title={sessionTitleFormatter.format('Publish session')}
      dialogMessage={sessionTitleFormatter.format(
        session.IsPublished
          ? 'This session is already published. Would you like to re-publish it?'
          : `Would you like to publish this session? It will be available for all users of ${tenantName}.`
      )}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      cancelButtonText='No'
      submitButtonText='Yes'
    />
  )
}

PublishSessionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  session: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    IsPublished: PropTypes.bool.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
}

export default memo(PublishSessionDialog)
